import { IPayerTaxFormResponse } from "@wingspanhq/payments/dist/interfaces";

import isNumber from "lodash/isNumber";
import { selectorIsTaxFormProcessing } from "./selectorIsTaxFormProcessing";

export const selector1099Total = (
  taxForm: IPayerTaxFormResponse
): number | undefined => {
  const { correction, data } = taxForm;

  if (selectorIsTaxFormProcessing(taxForm)) {
    return undefined;
  }

  if (isNumber(data?.totalAmount)) return data.totalAmount;

  if (isNumber(correction?.totalAmount)) return correction?.totalAmount;

  const platformIncome = data?.platformIncome;
  const adjustments = data?.adjustments;
  const paymentProcessingFees = data?.paymentProcessingFees;

  if (
    isNumber(platformIncome) &&
    isNumber(adjustments) &&
    isNumber(paymentProcessingFees)
  ) {
    return platformIncome + adjustments + paymentProcessingFees;
  }

  return undefined;
};
